import React from 'react';
import "./HeaderInfo.scss";

const HeaderInfo = () => {
  return (
    <div className='headerInfo'>
      <p className="headerInfo__description">professional team</p>
      <h3 className="headerInfo__title">the best new arrivals</h3>
    </div>
  );
}

export default HeaderInfo;